import { push } from 'connected-react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { generatePath } from 'react-router-dom';
import { HEARING_DETAILS_URL } from '../../../constants/urls';
import { allConcludedHearingsSelector } from '../../../features/selectors/compositeSelectors';
import { HearingOverview } from './HearingOverview';
import { Pages } from '../../../constants/pages';

const ConcludedHearingsPage = () => {
  const { t: translator } = useTranslation();
  const dispatch = useDispatch();

  const onHearingClick = (hearingItem) =>
    dispatch(push(generatePath(HEARING_DETAILS_URL, { id: hearingItem.key })));

  return (
    <div className="admin-page">
      <HearingOverview
        headerText={translator('pageNames.finalizedHearings')}
        initialShowGrid={true}
        hearingsSelector={allConcludedHearingsSelector}
        disableEsdh={true}
        disableOwner={true}
        disableSelection={true}
        onHearingClick={onHearingClick}
        activePage={Pages.ConcludedHearingsPage}
      />
    </div>
  );
};

export { ConcludedHearingsPage };
